import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { groMorePlatformManageAdd, groMorePlatformManageUpd } from "@/api/financial/consumptionDetails";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        site_id: "",
        special_product_id: ""
      },
      rules: {
        site_id: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        special_product_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px",
      interdits: false
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.interdits = data ? true : false;

                if (data) {
                  data.special_product_id = data.product_id;
                  _this.searchData = _this.processingData(_objectSpread({}, data));
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.searchData.id ? groMorePlatformManageUpd : groMorePlatformManageAdd;
          req(_objectSpread(_objectSpread({}, _this2.searchData), {}, {
            game_id: _this2.rawData.game_id
          })).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id,
        client_id: "",
        client_secret: '',
        refresh_token: '',
        project_id: ''
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};